import { useQuery } from '@tanstack/react-query';
import { checkLectureWatchtime } from '../../../../Utilities/api';
export const useCheckLectureWatchtime = ({ courseUuid, lectureUuid }) => {
    return useQuery({
        queryKey: ['lectureWatchtime', courseUuid, lectureUuid],
        queryFn: () => checkLectureWatchtime(courseUuid, lectureUuid),
        refetchInterval: 5000,
        staleTime: 3000,
    });
};
